import BaseComponent from "./BaseComponent";
import { OldSwitch } from "./OldSwitch";

export default class GroupPermission extends BaseComponent {
    /**
     * Group permission component for Permission tab in property panel
     * @module GroupPermission
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.data = this.props.value;
        this.toggleRefs = {};
    }

    getConfig(key) {
        return this.data[key];
    }

    setConfig(key, value) {
        if (key === "read" && value === false) {
            this.data["write"] = false;
            if (this.toggleRefs["write"]){
                this.toggleRefs["write"].toggle(false);
            }
        }
        if (key === "write" && value === true) {
            this.data["read"] = true;
            if (this.toggleRefs["read"]){
                this.toggleRefs["read"].toggle(true);
            }
        }
        this.data[key] = value;
        this.updateContext(this.data);
    }

    /**
     * Update context proxy; updates permission instead of doing a general update
     * @param {boolean} newValue
     */
    updateContext(newValue) {
        if (this.props.context && this.props.valKey) {
            this.props.context.setPermission(this.props.valKey, newValue);
        }
    }

    /**
     * Does the node has a write proxy?
     * @returns boolean
     */
    hasWriteProxy() {
        return true;
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div className={"form-component-container"}
                 style={{marginTop: "4px", display: "flex", alignItems: "center"}}>
                <table>
                    <tbody>
                    <tr>
                        <td colSpan={2}><label>{this.props.label}</label></td>
                    </tr>
                    <tr>
                        <td><OldSwitch context={this}
                                    label={this.getPropLabel("read")} valKey={"read"} checked={this.getConfig("read")}
                                    disabled={!this.props.canEdit}
                                    ref={ref => {
                                        if (ref) {
                                            this.toggleRefs["read"] = ref;
                                        }
                                    }}/></td>
                        <td><OldSwitch context={this}
                                    label={this.getPropLabel("write")} valKey={"write"} checked={this.getConfig("write")}
                                    disabled={!this.props.canEdit}
                                    ref={ref => {
                                        if (ref) {
                                            this.toggleRefs["write"] = ref;
                                        }
                                    }}/></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}